import Vue from "vue";
import VueRouter from "vue-router";
import { routes } from "./routes";
import store from "../store/index";
Vue.use(VueRouter);

let router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const checkUserAccess = async (to, from, next) => {
  if (to.name !== "Error" && !store.state.securityModule.hasAccessToApp) {
    next({
      path: "/error",
    });
    // landing page depends on the role, so it can only be resolved here — a
    // redirect on the route itself is applied before the user profile is loaded
  } else if (to.path === "/") {
    next({
      path: store.getters["securityModule/isProvider"]
        ? "/my-cases"
        : "/client/lookup",
    });
  } else if (
    to.meta.admin ||
    to.meta.eiAdmin ||
    to.meta.seitAdmin ||
    to.meta.rsAdmin ||
    to.meta.sc ||
    to.meta.provider
  ) {
    if (to.meta.admin && store.getters["securityModule/isAdmin"]) {
      next();
    } else if (to.meta.eiAdmin && store.getters["securityModule/isEIAdmin"]) {
      next();
    } else if (
      to.meta.seitAdmin &&
      store.getters["securityModule/isSEITAdmin"]
    ) {
      next();
    } else if (to.meta.rsAdmin && store.getters["securityModule/isRSAdmin"]) {
      next();
    } else if (
      to.meta.sc &&
      store.getters["securityModule/isServiceCoordinator"]
    ) {
      next();
    } else if (
      to.meta.provider &&
      store.getters["securityModule/isProvider"]
    ) {
      next();
    } else {
      next({
        path: "/error",
        query: { page: to.name, roles: [] },
      });
    }
  } else {
    next();
  }
};

// checkUserAccess redirects with next({ path }), which re-enters this guard.
// Holding one promise means the session resolves once for the whole chain
// instead of each hop racing a half loaded profile.
let sessionLoad = null;
const resolveSession = (returnPath) => {
  if (!Boolean(sessionLoad)) {
    sessionLoad = store.dispatch("securityModule/authenticate", returnPath);
  }
  return sessionLoad;
};

router.beforeEach(async (to, from, next) => {
  // await store.dispatch("securityModule/shallowAuthenticate");
  const isLoaded =
    store.state.securityModule.isAuthenticated &&
    Boolean(store.state.securityModule.userProfile.id);
  if (isLoaded) {
    checkUserAccess(to, from, next);
  } else if (to.matched.some((record) => record.meta.requiresAuth)) {
    store.commit("securityModule/setRequiresAuth", true);
    await resolveSession(to.path);
    checkUserAccess(to, from, next);
  } else {
    store.commit("securityModule/setRequiresAuth", false);
    next();
  }
});

export const showItem = function (item) {
  if (item.onNavBar == true) {
    if (
      item.meta.admin ||
      item.meta.eiAdmin ||
      item.meta.seitAdmin ||
      item.meta.rsAdmin ||
      item.meta.sc ||
      item.meta.provider
    ) {
      if (item.meta.admin && store.getters["securityModule/isAdmin"]) {
        return item;
      } else if (
        item.meta.eiAdmin &&
        store.getters["securityModule/isEIAdmin"]
      ) {
        return item;
      } else if (
        item.meta.seitAdmin &&
        store.getters["securityModule/isSEITAdmin"]
      ) {
        return item;
      } else if (
        item.meta.rsAdmin &&
        store.getters["securityModule/isRSAdmin"]
      ) {
        return item;
      } else if (
        item.meta.sc &&
        store.getters["securityModule/isServiceCoordinator"]
      ) {
        return item;
      } else if (
        item.meta.provider &&
        store.getters["securityModule/isProvider"]
      ) {
        return item;
      } else {
        return false;
      }
    } else {
      return item;
    }
  } else {
    return false;
  }
};

export default router;
